/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function MenuCloseIcon({ className }) {
	return (
		<svg className={classnames('svg', 'menu-close-icon', className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 29" width="41" height="29">
			<rect x="27" y="25" width="30" height="3" rx="1.5" transform="rotate(-135 27 25)" />
			<rect x="6" y="23" width="30" height="3" rx="1.5" transform="rotate(-45 6 23)" />
		</svg>
	);
}

MenuCloseIcon.propTypes = {
	className: PropTypes.string,
};
